import { Typography } from "@mui/material";
import React, { Component } from "react";

class NRHeadings extends Component {
    render() {
        return (
            <Typography variant="h4" fontWeight={"700"} textAlign={"center"}>
                Click on each card exactly once!
            </Typography>
        );
    }
}

export default NRHeadings;
